import { ReviewJsEnv } from '../review_js_env';

// RRサーバにリクエストを送る時に設定する、画面によって変わるパラメータ。
export const setRrRequestParams = (R3_COMMON: r3_common, pageOption: any) => {
  const R3_ADDTOCART = new r3_addtocart();
  R3_COMMON.addPlacementType(`add_to_cart_page.${pageOption.placementNameItemModal}`);
  R3_ADDTOCART.addItemIdToCart(pageOption.catalogItemCode);
};

export const createRrRequestParam = (model: ReviewJsEnv) => {
  return {
    isLogin: model.isLogin,
    userId: model.userId,
    userTracking: model.userTracking,
    userSegments: model.userSegments,
    setRrRequestParams: setRrRequestParams,
    pageOption: {
      placementNameItemModal: model.rrAreaProfileItemModal.placementName,
      catalogItemCode: model.catalogItemCode
    }
  };
}
